/** Pixen Intrigue — system overrides. Courtly-fae voice. */
export const systemPixEn = {
  // NotFoundPage
  'system.notFound.seoTitle': 'Lost in the Hedge',
  'system.notFound.heading': "You have wandered beyond the Court's edge",
  'system.notFound.body': 'The path you sought has been swallowed by the Hedge.',
  'system.notFound.returnCta': 'Return to the Court',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'An unknown disturbance rippled through the glamour.',
  'system.error.seoTitle': 'A Disturbance in the Glamour',
  'system.error.heading': 'The glamour faltered',
  'system.error.body':
    'Something unseen disrupted this page. The glamour is thin here — try again, or return to safer ground.',
  'system.error.returnCta': 'Return to the Court',

  // ErrorState (generic inline error card)
  'system.error.disturbanceTitle': 'A Disturbance in the Glamour',

  // DataState (DataError / DataEmpty defaults)
  'system.data.veilClouded': 'The Glamour Is Clouded',
  'system.data.scryingDark': 'The scrying glass has gone dark — this lore could not be summoned.',
  'system.data.archiveSilent': 'The Archive Is Silent',
  'system.data.stirsAsTwilightDeepens': 'Nothing stirs here yet. Return once the Salon reconvenes.',
}
